import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { selectIsMyPlayerIn } from '../../../redux/reducers/pokerReducer';
import { useAppSelector } from '../../../redux/store';
import { createAllCardRenderProperties } from './cardGroupUtils';
import { HoleCardDisplay } from './holeCardDisplay';
export const HoleCardsContainer = ({ groupContainerW, groupContainerH }) => {
    const isMyDiscardTurn = useAppSelector((state) => state.poker.isMyDiscardTurn);
    const numHoleCards = useAppSelector((state) => state.poker.holeCards?.length || 0);
    const isIn = useAppSelector(selectIsMyPlayerIn);
    const allCardRenderProperties = useMemo(() => createAllCardRenderProperties(groupContainerW, groupContainerH, numHoleCards), [groupContainerW, groupContainerH, numHoleCards]);
    if (!numHoleCards) {
        return null;
    }
    return (_jsx(_Fragment, { children: allCardRenderProperties.map((cardRenderProperties, i) => (_jsx(HoleCardDisplay, { cardIndex: i, isIn: isIn, cardRenderProperties: cardRenderProperties, isMyDiscardTurn: isMyDiscardTurn }, i))) }));
};
